import { render, staticRenderFns } from "./orderBusiness.vue?vue&type=template&id=5e595fb8&scoped=true&"
import script from "./orderBusiness.vue?vue&type=script&lang=ts&"
export * from "./orderBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./orderBusiness.vue?vue&type=style&index=0&id=5e595fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e595fb8",
  null
  
)

export default component.exports